import { gql } from "apollo-boost"

export const GET_MINISTRATION_PERIODS   = gql `
query GetMinistrationPeriods($skip: Float, $first: Float, $startDate: DateTime, $endDate: DateTime) {
    getMinistrationPeriodsMetadata(startDate: $startDate, endDate: $endDate)
    getMinistrationPeriods(skip: $skip, first: $first, startDate: $startDate, endDate: $endDate) {
        id
        orderIndex
        ministrationPlan {
            id
            submission {
                projectMonthStatus {
                    id
                    month
                    periodStatus
                    status
                    year
                }
                evidenced
                budgeted
                approved
                id
                agreementNumber
                name
                region
                implementer {
                    id
                    name
                }
            }
        }
        ministrationStartDate
        ministrationEndDate
        ministrationDueDate
        ministration {
            id
            paymentDate
            paymentAmount
            paymentBreakdown
            suppliedBreakdown
            savedBreakdown
            totalSupplied
            totalSaved
            totalNoSupplied
            ministrationDocuments {
                id
                url
                name
            }
            ministrationPaymentDocuments {
                id
                url
                name
            }
        }
        ministrationBudget {
            id
            implementer
            alliedOne
            alliedTwo
            ficosec
        }
    }
}
`
